
import { useState, useEffect } from 'react';
import client from '../../contentfulClientToken';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { INLINES } from '@contentful/rich-text-types';

gsap.registerPlugin(ScrollTrigger);

export default function Infos() {
    const [infosEtDevisData, setInfosEtDevisData] = useState(null); // Store the relevant fields


    useEffect(() => {
        const fetchPage = async () => {
            try {
                const response = await client.getEntries({ content_type: 'infosEtDevis' });

                /*     console.log(response); */

                if (response.items.length > 0) {
                    const { nomPage, texte, url, titre } = response.items[0].fields;

                    setInfosEtDevisData({ nomPage, texte, url, titre }); // Store only relevant fields
                }
            } catch (error) {
                console.error('Error fetching concept data:', error);
            }
        };

        fetchPage();
    }, []);

    // Allow editors to add classes via special hyperlink syntax in Contentful:
    // Select text -> add link with URL like: "span:highlight" or "span:highlight,emphasis"
    // This will render as <span class="highlight emphasis">...</span>
    const allowedSpanClasses = ['highlight', 'emphasis', 'note', 'small'];

    const renderOptions = {
        renderText: text =>
            text.split('\n').reduce((children, textSegment, index) => {
                return [...children, index > 0 && <br key={index} />, textSegment];
            }, []),
        renderNode: {
            [INLINES.HYPERLINK]: (node, children) => {
                const { uri } = node.data;
                // Custom syntax to render a span with classes instead of a link
                if (typeof uri === 'string' && uri.trim().toLowerCase().startsWith('span:')) {
                    const raw = uri.slice(5).trim();
                    // Support comma or space separated list of classes
                    const requested = raw
                        .split(/[,\s]+/)
                        .map((c) => c.trim())
                        .filter(Boolean);
                    // Whitelist classes to avoid injecting arbitrary class names
                    const classes = requested.filter((c) => allowedSpanClasses.includes(c));
                    const className = classes.join(' ') || 'highlight';
                    return <span className={className}>{children}</span>;
                }
                // Fallback to normal hyperlink rendering
                return (
                    <a href={uri} target="_blank" rel="noopener noreferrer">
                        {children}
                    </a>
                );
            },
        },
    };


    if (!infosEtDevisData) {
        return null; // Prevents rendering errors while data is loading
    }


    return (
        <section className="section-infos" data-content-type="infosEtDevis" id="infosEtDevis" data-background-color='#e7d8d8'>

            <div className='inner-container'>

                <div className="phrase" style={{ marginBottom: '15px' }}>
                    {documentToReactComponents(infosEtDevisData.titre, renderOptions)}
                </div>

                {/*  <div className="title" style={{ marginBottom: '15px' }}>
                    <p >{infosEtDevisData.nomPage}</p>
                </div> */}


                <div className="description">
                    {documentToReactComponents(infosEtDevisData.texte, renderOptions)}
                </div>


            </div>




        </section>
    );
}
